import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { ENVIRONMENT_SERVICE_TOKEN } from '@mwe/constants';
import { HTTPError, IKycStartRequest, IKycStartResponse, IKycStatusResponse } from '@mwe/models';
import { EnvironmentService } from '../environment/environment.service';

@Injectable({ providedIn: 'root' })
export class KycService {
  private readonly http = inject(HttpClient);
  private readonly environmentService = inject<EnvironmentService>(ENVIRONMENT_SERVICE_TOKEN);

  private readonly resourceUrl = this.environmentService.getApiUrl() + 'api/kyc/';

  async start(request: IKycStartRequest): Promise<IKycStartResponse> {
    try {
      return await lastValueFrom(this.http.post<IKycStartResponse>(this.getResourceUrl('start'), request, { withCredentials: true }));
    } catch (err) {
      throw new HTTPError(err.status, err.error, err.error?.message);
    }
  }

  async getStatus(): Promise<IKycStatusResponse> {
    try {
      return await lastValueFrom(this.http.get<IKycStatusResponse>(this.getResourceUrl('status'), { withCredentials: true }));
    } catch (err) {
      throw new HTTPError(err.status, err.error, err.error?.message);
    }
  }

  private getResourceUrl(path: string): string {
    return this.resourceUrl + path;
  }
}
